import Advices from "./Components/Advices/Advices";
import GlobalStyles from "./styles/global";
function App() {
  return (
    <>
      <Advices />
      <GlobalStyles />
    </>
  );
}

export default App;
